<div class="custella-modal">
    <div class="custella-modal-header align-items-center">
        <span class="text-14 font-medium ms-2" id="title_CheckProduct">
            {{mode === 'edit' ? translate?.general.buttons.edit.singular : translate?.general.buttons.new.singular}}
            {{translate?.setup.modules.inventory.userBin.label.singular}}</span>
        <i class="pi pi-times" (click)="modalRef.hide()" [pTooltip]="translate?.general.buttons.close.singular" id="btn_CheckProductClose"></i>
    </div>

    <div class="">
        <!-- Container -->
        <div class="custella-form-container position-relative d-block w-100 rounded-2 m-0">
            <form [formGroup]="addLocationForm" autocomplete="off" (ngSubmit)="onSubmitForm()">
                <div class="custella-form-container-title-two-grey fst-italic">
                    <div class="text-12 font-medium" id="subtitle_CheckProdAddProdQty">{{translate?.setup.modules.inventory.userBin.messages.selectUserCreateBin}}</div>
                </div>
                <div class="custella-form-container-content my-2">
                    <div class="custella-content-row mb-3">
                        <div class="custella-content-row-input col-6">
                            <span class="custella-content-row-input-title mandatory" id="label_SetInvUserBinUser">{{translate?.setup.users.users.label.singular}}</span>
                            <p-dropdown
                                [options]="users"
                                [showClear]="mode !== 'edit'"
                                optionLabel="fullName"
                                optionValue="id"
                                formControlName="user"
                                [placeholder]="translate?.general.messages.none"
                                (onChange)="onUserChange($event)"
                                id="picklist_SetInvUserBinUserField"
                            ></p-dropdown>

                            <div class="p-error text-10 col px-0 py-0 text-left" *ngIf="addLocationForm.controls['user'].touched && addLocationForm.controls['user'].invalid">
                                <span *ngIf="addLocationForm.controls['user'].errors?.required" id="label_SetInvUserBinUserRequiredField">{{translate?.general.validationFE.requiredField}}</span>
                            </div>
                        </div>
                        <div class="custella-content-row-input col-6">
                            <span class="custella-content-row-input-title mandatory" id="label_SetInvUserBinDisplayName">{{translate?.setup.modules.inventory.zones.fields.displayName.singular}}</span>
                            <input type="text" pInputText autocomplete="off" maxlength="254" formControlName="displayName" id="input_SetInvUserBinDisplayNameField" />

                            <div class="p-error text-10 col px-0 py-0 text-left" *ngIf="addLocationForm.controls['displayName'].touched && addLocationForm.controls['displayName'].invalid">
                                <span *ngIf="addLocationForm.controls['displayName'].errors?.required" id="label_SetInvUserBinDisplayNameRequiredField">{{translate?.general.validationFE.requiredField}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="custella-form-container-footer mb-0">
                <div class="flex-align-center justify-content-end">
                    <button class="custella-btn-white text-12 ms-2" id="btn_CheckProdCancel" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                    <p-button [disabled]="submitTouched" [label]="translate?.general.buttons.save.singular" styleClass="ms-2 h-32" id="btn_CheckProdSubmit" (onClick)="onSubmitForm()"></p-button>
                </div>
            </div>
        </div>
    </div>
</div>
